import { z } from "zod";

import { ListEventType } from "@signalist/shared-types";

// Event-outreach details whose fields become shared {event_*} template variables (PREC-3520).
export const ListEventCustomVariableSchema = z.object({
	key: z.string(),
	value: z.string(),
});

export const EventOutreachSchema = z.object({
	id: z.number().optional(),
	listId: z.number().optional(),
	enabled: z.boolean(),
	eventName: z.string().nullable().optional(),
	listType: z.nativeEnum(ListEventType).nullable().optional(),
	startDate: z.string().nullable().optional(),
	endDate: z.string().nullable().optional(),
	meetingLocation: z.string().nullable().optional(),
	meetingLink: z.string().nullable().optional(),
	meetingTimes: z.array(z.string()).nullable().optional(),
	customVariables: z.array(ListEventCustomVariableSchema).nullable().optional(),
});

export type EventOutreachSchemaType = z.infer<typeof EventOutreachSchema>;
